'use client'

import { subscribeNewsLetter } from '@/actions/authentication';
import Button from '@/components/ui/Button';
import PopupWrapper from '@/components/ui/PopupWrapper';
import useSizeController from '@/hooks/useSizeController';
import { AnimatePresence, motion } from 'framer-motion';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import Link from 'next/link';
import { useEffect, useState } from 'react';

const Confetti = dynamic(() => import('react-confetti'), { ssr: false });
const Congrate = dynamic(() => import('../../payment/(response)/successful/congrate'), { ssr: false });

export default function HomePopupDownloadApp() {
    const wpAsset = process.env.NEXT_PUBLIC_WP_ASSETS_BASE_URL
    const [email, setEmail] = useState('');
    const [success, setSuccess] = useState(false);
    const [close, setClose] = useState(false);
    const [error, setError] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    const [userAgent, setUserAgent] = useState('');

    useEffect(() => {
        if (navigator) {
            setUserAgent(navigator.userAgent);
        }
    }, []);

    const { innerHeight, innerWidth } = useSizeController();

    async function subscribe() {
        setIsLoading(true)
        const res = await subscribeNewsLetter(email);
        const { result, response } = JSON.parse(res);
        if (response.ok) {
            setSuccess(true);
            setTimeout(() => {
                setClose(true);
            }, 6000);
        } else if (response.status === 400) {
            setError('Seems like you are already subscribed! ')
        }
        setIsLoading(false)
    }
    const isAppleDevice = userAgent && /iPhone|iPad|iPod|Macintosh/i.test(userAgent);
    return (
        <PopupWrapper openAfterSeconds={5} openByScroll={false} close={close} identifier='downloadApp'>
            <div className='md:grid py-4 md:py-0 min-w-80 md:grid-cols-[280px,_480px] gap-2 font-semibold text-lg'>

                <div
                    className='md:grid py-4 md:py-0 min-w-80 md:grid-cols-[280px,_480px] gap-2 font-semibold text-lg'>
                    <div className=' flex items-center justify-center relative'>
                        <Image
                            width={400}
                            height={400}
                            className='relative z-10 w-2/3 md:w-full h-full'
                            alt='Newsletter Image'
                            src={`${process.env.NEXT_PUBLIC_STORAGE_URL}assets/ddb100e3-29e9-405a-9c62-ec40b7d6c1e6-planingo.png`}
                        />
                    </div>
                    <AnimatePresence mode='wait'>
                        {success ? (
                            <motion.div
                                key='success'
                                animate={{ opacity: 1, scale: 1 }}
                                exit={{ opacity: 0, scale: 0.9 }}
                                transition={{ duration: 0.5 }}
                                className='flex items-center justify-center gap-2 flex-col h-full w-full'>
                                <Confetti width={innerWidth} height={innerHeight || undefined} />
                                <Congrate />
                                <p className='mt-4 text-sm text-neutral-700'>You won&apos;t regret it!</p>
                            </motion.div>
                        ) : (<motion.div
                            key='content'
                            initial={{ opacity: 0, x: -50 }}
                            animate={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: 50 }}
                            transition={{ duration: 0.5 }}
                            className='flex flex-col px-4 md:px-6 mt-6 md:pr-10 md:mt-0 items-start justify-center h-full'>
                            <p className='text-neutral-900'>Hey, Wanna Travel Better and Smarter?</p>
                            <p className='text-neutral-600 mt-1 font-normal text-sm'>
                                Our app brings your travel experience to the next level through AI-generated itineraries and AI-recommended stays. Download it and get a 10% discount.
                            </p>
                            <div className='mt-8 flex md:flex-row flex-col items-start gap-2 w-full'>
                                <div className='hidden md:flex items-center w-full justify-between'>
                                    <Image
                                        width={400}
                                        height={400}
                                        className='relative z-10 size-16 rounded h-full'
                                        alt='Download app QR code'
                                        src={`${process.env.NEXT_PUBLIC_STORAGE_URL}assets/c9e0fb25-84bd-4345-99dd-814624c79c19-planingo.png`}
                                    />
                                    <div className='text-sm font-normal'>
                                        or
                                    </div>
                                    <div className='flex items-center gap-4 '>
                                        <Link target='_blank' className="hover:text-primary-700 text-xs text-neutral-600 font-medium"
                                            href="https://apps.apple.com/tr/app/planingo/id6504288085">
                                            <Image className='w-[135px]' width={300} height={150} alt='App Store'
                                                src={`${process.env.NEXT_PUBLIC_STORAGE_URL}assets/34fbb833-49ae-4fea-b2d3-5c4a2c039ebd.png`} /></Link>

                                        <Link target='_blank' className="hover:text-primary-700 text-xs text-neutral-600 font-medium"
                                            href="https://play.google.com/store/apps/details?id=ai.planingo">
                                            <Image className='w-[135px]' width={300} height={150} alt='Google Store'
                                                src={`${process.env.NEXT_PUBLIC_STORAGE_URL}assets/0fe7f354-9653-47f5-bffb-3bd8a3039916.png`} /></Link>
                                    </div>
                                </div>
                                <Link
                                    className='w-full md:hidden'
                                    href={isAppleDevice ? "https://apps.apple.com/tr/app/planingo/id6504288085" : "https://play.google.com/store/apps/details?id=ai.planingo"} target='_blank'>
                                    <Button isLoading={isLoading} onClick={subscribe} className='w-full md:hidden  min-w-max' color='indigo'>
                                        Get the App
                                    </Button>
                                </Link>
                            </div>
                        </motion.div>)}
                    </AnimatePresence>
                </div>


            </div>
        </PopupWrapper>
    );
}
